import { useContext } from 'react';
import { CanvasesContext } from '../store';

export function useCanvasErrorState() {
	const { state: canvasState } = useContext(CanvasesContext);
	const { error } = canvasState;

	return { error };
}
